<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal ">
          <div class="modal-head"><h1>부의금 계좌 안내</h1></div>
          <div class="modal-con">
            <ul class="modal-info-gray-area">
              <li>
                <p class="title">예금주</p>
                <p class="text">{{ depositor }}</p>
              </li>
              <li>
                <p class="title">은행</p>
                <p class="text">{{ bank }}</p>
              </li>
              <li>
                <p class="title">계좌번호</p>
                <p class="text">{{ accountNumber }} <i class="ico-copy" @click="fnCopy"></i></p>
              </li>
            </ul>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn primary medium" @click="close">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, toRefs } from 'vue';
import { showTextModal } from '@/common/utils/ModalState';
import { isIPhone } from '@/common/utils/module/IsMobileSupport';
import { androidCopy, nativeCopyText } from '@/common/utils/module/NativeRequest';

const props = defineProps(['data']);
const { bank, accountNumber, depositor } = toRefs(props.data);
const emits = defineEmits(['close']);

const on = ref(false);

const fnCopy = () => {
  showTextModal('복사되었습니다.', '확인');
  if (!isIPhone()) {
    androidCopy(`${bank.value} - ${accountNumber.value}`);
  } else {
    navigator.clipboard.writeText(`${bank.value} - ${accountNumber.value}`);
    // }
    // if (navigator.clipboard && navigator.clipboard.writeText) {
    // } else {
    //   console.error('Clipboard API is not supported in this browser.');
  }
};

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
